import React, { PropTypes } from 'react';

const Actions = ({ canDeny, requestAccepted, deny, approve }) => (
  <span>
    { requestAccepted !== true &&
    <button className="btn btn-icon-only" type="button" onClick={approve}>
      <i className="fa fa-thumbs-up"/>
    </button> }

    { requestAccepted !== false && canDeny &&
    <button className="btn btn-icon-only" type="button" onClick={deny}>
      <i className="fa fa-thumbs-down"/>
    </button> }
  </span>
);

Actions.propTypes = {
  canDeny: PropTypes.bool,
  requestAccepted: PropTypes.bool,
  deny: PropTypes.func.isRequired,
  approve: PropTypes.func.isRequired,
};

export default Actions;



// WEBPACK FOOTER //
// ./project/components/access_type_action.jsx